<template>
  <HeaderBlock msg="HeaderBlock" />
  <NavBlock msg="NavBlock" />
  <!-- title -->
  <div class="page-wrapper">
    <div class="page-header d-print-none">
      <div class="container-xl">
        <div class="row g-2 align-items-center">
          <div class="col">
            <!-- Page pre-title -->
            <div class="page-pretitle"></div>
            <h3 class="card-body">
              <ol class="breadcrumb breadcrumb-arrows">
                <li class="breadcrumb-item" :class="{ 'active': step == 1 }"><a href="#" @click="goStep(1)">开始准备</a>
                </li>
                <li class="breadcrumb-item" :class="{ 'active': step == 2 }"><a href="#" @click="goStep(2)">安装Sumsg Smart集成</a>
                </li>
                <li class="breadcrumb-item" :class="{ 'active': step == 3 }"><a href="#" @click="goStep(3)">完成</a></li>
              </ol>
            </h3>
          </div>
        </div>
      </div>
    </div>
    <!-- table -->
    <div class="page-body">
      <!-- 1 -->
      <div class="container container-tight py-4" v-if="step == 1">
        <h2 class="mb-3">开始准备</h2>
        <p class="text-secondary">
          <b  class="text-orange">此集成支持<a href="https://www.sumsg.com/wifibootcard/docs/" target="_blank">[网络版本]</a>和<a href="https://www.sumsg.com/HA-WBC-2/docs/" target="_blank">[局域网版本]</a>接入。 <br/>网络版本可以从APP里的固件更新历史中刷入局域网版本固件。</b>
        </p>
        <p class="text-secondary">
          以下是本设备使用Home Assistant的必要条件。
        </p>
        <ul class="list-unstyled space-y">
          <li class="row g-2">
            <span class="col-auto"> <i class="fa fa-check-circle text-success"></i> </span>
            <span class="col">
              <strong class="d-block">远程开机卡</strong>
              <span class="d-block text-secondary">目前适配了远程开机卡一代和二代，以及局域网版本。 本平台其他设备未适配。</span>
            </span>
          </li>
          <li class="row g-2">
            <span class="col-auto"> <i class="fa fa-check-circle text-success"></i> </span>
            <span class="col">
              <strong class="d-block">Home Assistant服务</strong>
              <span class="d-block text-secondary">已经成功安装Home Assistant服务，并可以正常使用。</span>
            </span>
          </li>
          <li class="row g-2">
            <span class="col-auto"> <i class="fa fa-check-circle text-success"></i> </span>
            <span class="col">
              <strong class="d-block">设备绑定成功</strong>
              <span class="d-block text-secondary">设备需要成功配网，APP能正常控制。</span>
            </span>
          </li>
          <li class="row g-2">
            <span class="col-auto"> <i class="fa fa-check-circle text-default"></i> </span>
            <span class="col">
              <strong class="d-block">桌面电脑</strong>
              <span class="d-block text-secondary">可以访问Home Assistant服务配置的桌面电脑，用来配置。非必须。</span>
            </span>
          </li>
        </ul>
        <div class="my-4">
          <a class="btn btn-primary w-100" @click="goStep(2)">
            下一步 安装Sumsg Smart集成
          </a>
        </div>
        <p class="text-secondary">
        </p>
      </div>
      <!-- 2 -->
      <div class="container container-tight py-4" v-if="step == 2">
        <h2 class="mb-3">安装Sumsg Smart集成</h2>
        <p class="text-secondary mb-4">Sumsg Smart 集成 地址： 
          <a href="https://github.com/sumsg/sumsg_smart" target="_blank">
            https://github.com/sumsg/sumsg_smart
          </a>
          <br/><br/>
          国内用户若无法访问，请点此<a href="https://www.sumsg.com/wifibootcard/HomeAssistant/sumsg_smart-latest.zip" target="_blank">本地下载</a>, ⚠️ 注意 本地下载版本可能不是最新版, 请尽量从  <a href="https://github.com/sumsg/sumsg_smart" target="_blank">Github</a> 下载.
        </p>
        <ul class="steps steps-counter steps-vertical">
          <li class="step-item">
            <div class="h4 m-0"><i class="fa-solid fa-gear"></i> 集成位置</div>
            <div class="text-secondary">
              <p></p>
              <p>1. 打开 <span class="badge bg-indigo-lt">Home Assistant</span> 配置目录（config）。</p>
              <p>2. 打开配置目录下的<span class="badge bg-indigo-lt">custom_components</span>文件夹，如果不存在请手动创建。</p>
              <p>3. 把下载的 <span class="badge bg-indigo-lt">Sumsg Smart 集成</span>解压</p>
              <p>4. 把解压后的文件夹中的<span class="badge bg-indigo-lt">sumsg_smart</span>,放在custom_components目录下</p>
              <p>目录结构如下图所示：</p>
              <p>
                <a href="/img/home_assistant/hass_3.png" target="_blank">
                  <img src="/img/home_assistant/hass_3.png" class="img-big">
                </a>
              </p>
              <p>配置目录路径：<br />
                不同的操作系统，路径不同，以下仅供参考。</p>
              <div class="card">
                <div class="table-responsive">
                  <table class="table table-vcenter card-table table-striped">
                    <thead>
                      <tr>
                        <th>操作系统</th>
                        <th>路径</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>macOS</td>
                        <td>~/.homeassistant</td>
                      </tr>
                      <tr>
                        <td>Linux</td>
                        <td>~/.homeassistant</td>
                      </tr>
                      <tr>
                        <td>Windows</td>
                        <td>%APPDATA%/.homeassistant</td>
                      </tr>
                      <tr>
                        <td>Docker</td>
                        <td>您自定义映射路径，或/config</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </li>
          <li class="step-item">
            <div class="h4 m-0"><i class="fa-solid fa-plus"></i> 添加集成</div>
            <div class="text-secondary">
              <p></p>
              <p>在页面右下角找到“添加集成”。</p>
              <p>
                <a href="/img/home_assistant/mqtt_install_2.png" target="_blank">
                  <img src="/img/home_assistant/mqtt_install_2.png" class="img-big">
                </a>
              </p>
              <p>搜索“Sumsg“。</p>
              <p>
                <a href="/img/home_assistant/hass_2.png" target="_blank">
                  <img src="/img/home_assistant/hass_2.png" class="img-big">
                </a>
              </p>
              <p>输入您在 APP 注册的账号和密码</p>
              <p>
                <a href="/img/home_assistant/hass_1.png" target="_blank">
                  <img src="/img/home_assistant/hass_1.png" class="img-big">
                </a>
              </p>
            </div>
          </li>
        </ul>
        <div class="my-4">
          <div class="row">
            <div class="col-6">
              <a class="btn btn-default w-100" @click="goStep(1)">上一步 安装Sumsg Smart集成
              </a>
            </div>
            <div class="col-6">
              <a class="btn btn-primary w-100" @click="goStep(3)">下一步 完成</a>
            </div>
          </div>
        </div>
        <p class="text-secondary">
        </p>
      </div>
      <!-- 3 -->
      <div class="container container-tight py-4" v-if="step == 3">
        <h2 class="mb-3">完成</h2>
        <p class="text-secondary mb-4">
          恭喜您，现在您可以在Home Assistant中体验了。
        </p>
        <ul class="steps steps-counter steps-vertical">
          <li class="step-item">
            <div class="h4 m-0"><i class="fa fa-solid fa-bars-progress"></i> 概览</div>
            <div class="text-secondary">
              <p></p>
              <p>这是在概览中展示的界面</p>
              <p>
                <a href="/img/home_assistant/show_2.png" target="_blank">
                  <img src="/img/home_assistant/show_2.png" class="img-big">
                </a>
              </p>
            </div>
          </li>
        </ul>
        <div class="my-4">
          <a class="btn btn-default w-100" @click="goStep(2)">上一步 安装Sumsg Smart集成 </a>
        </div>
      </div>
    </div>
  </div>

  <FooterBlock msg="FooterBlock" />
</template>

<script>
import HeaderBlock from '../components/HeaderBlock.vue'
import FooterBlock from '../components/FooterBlock.vue'
import NavBlock from '../components/NavBlock.vue'
export default {
  name: 'HomeAssistantPage',
  components: {
    HeaderBlock,
    FooterBlock,
    NavBlock,
  },
  data() {
    return {
      global: global,
      step: 1
    };
  },
  methods: {
    goStep: function (s) {
      this.step = s;
    },
  },
}
</script>
<style scoped>
.img-big {
  border-radius: 5px;
  border: 1px solid #206bc4;
  padding: 2px;
  margin-right: 5px;
}

.card-border {
  border: 1px solid #206bc4;
}
</style>